"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ChatInterface_1 = require("../../BusinessLogicLayer/ChatInterface");
const getAttachment = (mediaId) => {
    const mediumSize = 500;
    const thumbnailSize = 100;
    const attachment = {
        mediaId: mediaId,
        sizes: {
            large: {
                size: {
                    width: mediumSize,
                    height: mediumSize,
                },
                url: `https://via.placeholder.com/${mediumSize}`,
                authRequired: true,
            },
            medium: {
                size: {
                    width: mediumSize,
                    height: mediumSize,
                },
                url: `https://via.placeholder.com/${mediumSize}`,
                authRequired: true,
            },
            thumbnail: {
                size: {
                    height: thumbnailSize,
                    width: thumbnailSize,
                },
                url: `https://via.placeholder.com/${thumbnailSize}`,
                authRequired: false,
            },
        },
    };
    return attachment;
};
const defaultChatStorage = (customerId, coachId) => {
    const messages = [];
    let messageId = 1000;
    const coachMessage = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco?";
    const memberMessage = "Sunt in culpa qui officia deserunt mollit anim id est laborum.";
    for (let m = 0; m < 60; m += 2) {
        const minutes = m < 10 ? "0" + m : m.toString();
        const minutesResponse = m + 1 < 10 ? "0" + (m + 1) : (m + 1).toString();
        messages.push({
            authorId: coachId,
            authorDisplayName: "Author #" + coachId,
            level: null,
            message: {
                id: (messageId++).toString(),
                isoDateTime: "2019-07-29T11:" + minutes + ":00+01:00",
                messageParts: [
                    {
                        name: ChatInterface_1.MessagePartType.TEXT,
                        text: coachMessage,
                    },
                ],
                attachment: m === 58
                    ? getAttachment(`${coachId}${m}`)
                    : null,
            },
        });
        messages.push({
            authorId: customerId,
            authorDisplayName: "Author #" + customerId,
            level: null,
            message: {
                id: (messageId++).toString(),
                messageParts: [
                    {
                        name: ChatInterface_1.MessagePartType.TEXT,
                        text: memberMessage,
                    },
                ],
                isoDateTime: "2019-07-29T11:" + minutesResponse + ":00+01:00",
                attachment: m === 58
                    ? getAttachment(`${coachId}${m}`)
                    : null,
            },
        });
    }
    const testRichMessage = [
        {
            name: ChatInterface_1.MessagePartType.TEXT,
            text: "Text Part 😇",
        },
        {
            name: ChatInterface_1.MessagePartType.DATE,
            isoDate: "1999-01-01T00:00:00+01:00",
        },
        {
            name: ChatInterface_1.MessagePartType.LINK,
            url: "https://pbp.local/graphql?query={user{id}}",
            label: "click me!",
        },
        {
            name: ChatInterface_1.MessagePartType.RICH_TEXT,
            text: "make me bold ",
            methods: [
                {
                    type: ChatInterface_1.RichPartMethodType.TYPOGRAPHICAL_EMPHASIS,
                    subType: ChatInterface_1.TypographicalEmphasis.BOLD,
                },
            ],
        },
    ];
    messages.push({
        authorId: "team_pbp",
        authorDisplayName: "Team PBP",
        level: ChatInterface_1.MessageLevel.INFO,
        message: {
            id: (messageId++).toString(),
            messageParts: testRichMessage,
            isoDateTime: "2020-01-01T00:00:00+12:00",
        },
    });
    messages.push({
        authorId: "admin",
        authorDisplayName: "Personal Body Plan",
        level: ChatInterface_1.MessageLevel.WARN,
        message: {
            id: (messageId++).toString(),
            messageParts: testRichMessage,
            isoDateTime: "2020-01-01T00:00:00-12:00",
        },
    });
    return messages;
};
exports.default = defaultChatStorage;
//# sourceMappingURL=defaultChatStorage.js.map